(function () {
    'use strict';

    angular
        .module('ib-basket-module')
        .controller('BasketController', BasketController);

    BasketController.$inject = ['$window', '$rootScope', 'CurrencyService', '$scope', 'MenusConstants', 'localStorageService', '$timeout', 'CommonsModalService', 'CommonsAncillariesService', '$controller', 'ShoppingBasketViewModel', 'ibBasketTransformer'];
    function BasketController ($window, $rootScope, CurrencyService, $scope, MenusConstants, localStorageService, $timeout, CommonsModalService, CommonsAncillariesService, $controller, ShoppingBasketViewModel, ibBasketTransformer) {
        const vm = this;

        vm.$onInit = activate;
        vm.$onChanges = activate;
        vm.logoUri = $window.location.origin;
        vm.goToPayment = goToPayment;
        vm.calculateAllBasket = calculateAllBasket;
        vm.saveHeaderModel = saveHeaderModel;
        vm.updateHeaderBaggages = updateHeaderBaggages;
        vm.updateHeaderBundle = updateHeaderBundle;

        vm.commonsBasketFunctions = {
            calculateAllBasket: vm.calculateAllBasket,
            saveHeaderModel: vm.saveHeaderModel,
            isLoading: isLoadingBasket,
            isNotLoading: isNotLoadingBasket,
            collapseHeader: $controller('IbHeaderCollapseController'),
            modalService: CommonsModalService,
            deleteAncillariesService: CommonsAncillariesService,
            CurrencyService: CurrencyService
        };
        vm.isLoadingVoucher = false;
        vm.flowApp = '';


        $scope.$on('initializeHeader', initializeHeader);
        $scope.$on('updateHeaderCurrency', updateCurrency);
        $scope.$on('updateHeaderTrips', updateTrips);
        $scope.$on('updateHeaderSeats', updateHeaderSeats);
        $scope.$on('updateHeaderUpgrading', updateHeaderUpgrading);
        $scope.$on('updateHeaderInsurance', updateHeaderInsurance);
        $scope.$on('updateHeaderBaggages', updateHeaderBaggages);
        $scope.$on('updateHeaderBundle', updateHeaderBundle);
        $scope.$on('updateHeaderBasket', updateBasket);
        $scope.$on('updateMmbHeaderBasket', updateMmbBasket);
        $scope.$on('updateCkiHeaderBasket', updateCkiBasket);
        $scope.$on('changeStatusBasket', changeStatusBasket);
        $scope.$on('updateTripList', updateTripList);
        $scope.$on('updateHeaderSpeqs', updateHeaderSpeqs);
        $scope.$on('updateHeaderCarbonFootprint', updateHeaderCarbonFootprint);
        $scope.$on('updateHeaderGlobickTransfers', updateHeaderGlobickTransfers);
        $scope.$on('updateHeaderGlobickActivities', updateHeaderGlobickActivities);
        $scope.$on('updateHeaderAllianzFusionInsurance', updateHeaderAllianzFusionInsurance);
        $scope.$on('deleteFees', deleteFees);
        $scope.$on('updatePendingItems', updatePendingItems);
        $scope.$on('loadingVoucherBasket', loadingVoucherBasket);
        $scope.$on('resetHeaderCurrency', resetCurrency);

        function activate () {
            formatPrice();
            updateTotalBasket();
            vm.flowApp = localStorageService.get('flowApp');
        }

        function formatPrice () {
            let totalPrice;
            if (vm.model.total && vm.model.total.original) {
                totalPrice = vm.model.total.original;
            } else {
                vm.model.total = {};
                totalPrice = 0;
            }
            vm.model.total.formatted = CurrencyService.formatPrice(vm.model.currency, totalPrice, true);
        }


        /**
        * Emits event for go to payment page
        */
        function goToPayment () {
            $rootScope.$broadcast('goToPayment');
        }

        /**
         * Change status for show or hide basket
         * @param {*} evt
         * @param {*} status
         */
        function changeStatusBasket (evt, status) {
            vm.model.showBasket = status;
        }


        /**
         * Emits event with total of basket formatted
         */
        function updateTotalBasket () {
            const actualPage = $window.location.hash.substring(2);

            if (actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.BOOKING || MenusConstants.ANCILLARIES_PAGES_HASH.CHECKIN) {
                $timeout(() => {
                    $rootScope.$broadcast('totalBasket', vm.model.total.formatted);
                });
            }
        }


        /**
         * Set initial values to model of header
         *
         * @param {Object} evt
         * @param {Object} model Model data
         */
        function initializeHeader (evt, model) {
            vm.model.initializeModel();
            if (model.trips && model.trips.trips) {
                updateTrips(null, model.trips.trips);
            }
            if (model.basket) {
                updateBasket(null, model.basket);
                if (model.basket.currency) {
                    vm.model.currency = model.basket.currency;
                }
            }

            if (model.loggedInfo.isLogged) {
                vm.model.loggedInfo = model.loggedInfo;
            }
            saveHeaderModel();
        }


        /**
         * Save header model on localStorage
         */
        function saveHeaderModel () {
            const mainHeaderModel = getHeaderModel();
            mainHeaderModel.headerModel.shoppingBasket = vm.model;
            mainHeaderModel.shoppingBasket = vm.model;
            localStorageService.remove('headerModel');
            localStorageService.set('headerModel', mainHeaderModel);
        }


        /**
         * Recover header model of localStorage
         */
        function getHeaderModel () {
            return localStorageService.get('headerModel');
        }


        /**
       * Update seats on basket
       * @param {Object} evt
       * @param {Object} data
       */
        function updateHeaderSeats (evt, data) {
            let i, k, j, l, isSeatFound = false, isPassengerFound = false, seatFound = false,
                segmentFound = false, isEarly = checkEarlySegments(data.segmentId), subTotal, segmentIdSeat,
                seatsSelectedInfoData = localStorageService.get('seatsSelectedInfoData') ? localStorageService.get('seatsSelectedInfoData') : {};
            segmentIdSeat = data.segmentId.toString();
            seatsSelectedInfoData[segmentIdSeat] = data;
            seatsSelectedInfoData[segmentIdSeat].id = segmentIdSeat;
            if (vm.model.seats.hasSeats === undefined) {
                vm.model.seats.hasSeats = false;
                vm.model.seats.segments = [];
            }
            for (i = 0; i < vm.model.seats.segments.length; i++) {
                if (data.segmentId.toString() === vm.model.seats.segments[i].segmentId) {
                    segmentFound = true, k = 0;

                    for (k = 0; k < data.passengers.length; k++) {
                        isSeatFound = false;
                        // eslint-disable-next-line no-loop-func
                        angular.forEach(vm.model.seats.segments[i].seats, (seat) => {
                            j = 0, isPassengerFound = false;
                            while (j < seat.passengers.length && !isPassengerFound && !isSeatFound) {
                                if (data.passengers[k].id.toString() === seat.passengers[j].id.toString() && data.passengers[k].seatType === seat.type && !data.passengers[k].isDeletedFromSeatmap) {
                                    seat.passengers[j].amount = data.passengers[k].price;
                                    seat.type = data.passengers[k].seatType;
                                    seat.description = data.passengers[k].seatTypeDescription;
                                    isSeatFound = true;
                                } else if (data.passengers[k].id.toString() === seat.passengers[j].id.toString() && (data.passengers[k].seatType !== seat.type || data.passengers[k].isDeletedFromSeatmap)) {
                                    seat.quanty--;
                                    seat.amount = seat.amount - seat.passengers[j].amount;
                                    seat.totalFormatted = CurrencyService.formatPrice(vm.model.currency, seat.amount, true);
                                    if (seat.passengers.length === 1) {
                                        seat.passengers = [];
                                    } else {
                                        l = 0;
                                        while (l < seat.passengers.length && !seatFound) {
                                            if (seat.passengers[l].id === data.passengers[k].id.toString()) {
                                                seatFound = true;
                                                seat.passengers.splice(l, 1);
                                            }
                                            l++;
                                        }
                                    }
                                    if (!localStorageService.get('newSeatsMap')) {
                                        isPassengerFound = true;
                                    }
                                }
                                j++;
                            }
                        });
                        if (!isSeatFound  && !data.passengers[k].isDeletedFromSeatmap) {
                            addNewSeat(vm.model.seats.segments[i], data.passengers[k]);
                        }
                    }

                    calculateTotalSegment(vm.model.seats.segments[i]);
                    cleanEmptySegments(vm.model.seats.segments);
                }
            }

            if (!segmentFound) {
                vm.model.seats.segments.push(generateSeatSegment(data.segmentId.toString(), data.passengers));
            }
            if (vm.model.seats.segments.length > 0) {
                vm.model.seats.hasSeats = true;
            } else {
                vm.model.seats.hasSeats = false;
            }

            calculateSeatTypePrice(vm.model.seats.segments);
            calculateSubTotalSeats();
            calculateAllBasket();

            vm.model.seats = ibBasketTransformer.checkFreeSeats(vm.model.seats);
            seatsSelectedInfoData = setPriceFormatted(seatsSelectedInfoData);
            localStorageService.set('seatsSelectedInfoData', seatsSelectedInfoData);


            saveHeaderModel();
            function generateSeatSegment (segmentId, seatPassengers) {
                let segment = { segmentId: segmentId, isEarly: isEarly, seats: [], origin: null, destination: null, quanty: 0, total: 0, totalFormatted: 0 }, i, segmentInfo = localStorageService.get('segmentsInfo');
                angular.forEach(seatPassengers, (seatPas) => {
                    addNewSeat(segment, seatPas);
                    segment.quanty++;
                });
                if (vm.model.segmentsInfo.length > 0) {
                    for (i = 0; i < vm.model.segmentsInfo.length; i++) {
                        if (vm.model.segmentsInfo[i].id === segment.segmentId) {
                            segment.origin = vm.model.segmentsInfo[i].origin;
                            segment.destination = vm.model.segmentsInfo[i].destination;

                        }
                    }
                } else {
                    for (i = 0; i < segmentInfo.length; i++) {
                        if (segmentInfo[i].id === segment.segmentId) {
                            segment.origin = segmentInfo[i].origin;
                            segment.destination = segmentInfo[i].destination;

                        }
                    }
                }
                calculateTotalSegment(segment);
                return segment;
            }

            function setPriceFormatted (info) {
                angular.forEach(info, (segment) => {
                    angular.forEach(segment.passengersInfo, (passenger) => {
                        passenger.seatPriceFormatted = CurrencyService.formatPrice(vm.model.currency, passenger.seatPrice, true);
                    });
                });
                return info;
            }

            function addNewSeat (segment, seatPas) {
                let i = 0, isFound = false, seatType;

                while (i < segment.seats.length && !isFound) {
                    if (segment.seats[i].type === seatPas.seatType) {
                        segment.seats[i].passengers.push({ id: seatPas.id.toString(), amount: seatPas.price });
                        segment.seats[i].amount += seatPas.price;
                        segment.seats[i].totalFormatted = CurrencyService.formatPrice(vm.model.currency, segment.seats[i].amount, true);
                        segment.seats[i].quanty++;
                        isFound = true;
                    }
                    i++;
                }

                if (!isFound) {
                    seatType = { type: seatPas.seatType, description: seatPas.seatTypeDescription, quanty: 1, passengers: [], amount: 0, totalFormatted: null };
                    seatType.amount += seatPas.price;
                    seatType.totalFormatted = CurrencyService.formatPrice(vm.model.currency, seatType.amount, true);
                    seatType.passengers.push({ id: seatPas.id.toString(), amount: seatPas.price });
                    segment.seats.push(seatType);
                }
            }

            function calculateSeatTypePrice (segments) {
                let i, k, segmentsSeats;

                for (i = 0; i < segments.length; i++) {
                    segmentsSeats = [];
                    for (k = 0; k < segments[i].seats.length; k++) {
                        if (segments[i].seats[k].quanty > 0) {
                            segmentsSeats.push(segments[i].seats[k]);
                        }
                    }
                    angular.forEach(segmentsSeats, (seat) => {
                        seat.amount = 0;
                        angular.forEach(seat.passengers, (pas) => {
                            seat.amount += pas.amount;
                        });
                        seat.totalFormatted = CurrencyService.formatPrice(vm.model.currency, seat.amount, true);
                    });

                    segments[i].seats = segmentsSeats;
                }
            }

            function calculateTotalSegment (segment) {
                segment.total = 0;
                segment.totalFormatted = null;
                angular.forEach(segment.seats, (seat) => {
                    if (seat.quanty > 0) {
                        angular.forEach(seat.passengers, (pas) => {
                            segment.total += pas.amount;
                        });
                    }
                });
                segment.totalFormatted = CurrencyService.formatPrice(vm.model.currency, segment.total, true);
            }

            function cleanEmptySegments (segments) {
                let seats;
                angular.forEach(segments, (segment) => {
                    seats = null;
                    seats = segment.seats.filter((seat) => {
                        return (seat.quanty > 0);
                    });
                    segment.seats = seats;
                });
                if (localStorageService.get('newSeatsMap')) {
                    vm.model.seats.segments = segments.filter((segment) => segment.seats.length > 0);
                }
            }

            function calculateSubTotalSeats () {
                subTotal = 0;
                angular.forEach(vm.model.seats.segments, (segment) => {
                    subTotal += segment.total;
                });
                vm.model.seats.total = {
                    total: subTotal,
                    totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
                };
            }
        }



        /**
         * Update or add baggages to basket model
         * @param {Object} evt Event
         * @param {Array} passengerBaggages List of passenger baggages
         */
        function updateHeaderBaggages (evt, passengerBaggages) {
            let isSegmentFound = false, baggage, totalBaggage, subTotal, segmentInfo, baggageFound, baggageInfo;
            const selectedBundle = localStorageService.get('selectedBundle');
            vm.model.baggages.segments = [];
            vm.model.baggages.hasBaggage = false;
            if(selectedBundle) {
                calculateBundleBaggages(selectedBundle, passengerBaggages);
            }

            angular.forEach(passengerBaggages, (passenger) => {
                angular.forEach(passenger.trips, (trip) => {
                    isSegmentFound = false;
                    if (vm.model.baggages.segments.length > 0) {
                        angular.forEach(vm.model.baggages.segments, (segment) => {
                            if (trip.id === segment.segmentId) {
                                angular.forEach(trip.pieces, (piece) => {
                                    baggageFound = false;
                                    if (piece.quantySelected > 0) {
                                        angular.forEach(segment.baggages, (baggage) => {
                                            if (piece.subtype === baggage.type) {
                                                baggageFound = true;
                                                totalBaggage = calculateToltalBaggageRange(piece.quantySelected, piece.availablePriceRanges, piece.bundlePieces);
                                                baggage.quanty += piece.quantySelected;
                                                baggage.total += totalBaggage.total;
                                                segment.total += totalBaggage.total;
                                                baggage.totalFormatted = CurrencyService.formatPrice(vm.model.currency, baggage.total, true);
                                                vm.model.baggages.hasBaggage = true;
                                                calculateToltalBaggageRange(baggage.quanty, piece.availablePriceRanges, piece.bundlePieces);
                                                if (baggage.passengers.indexOf(passenger.id) === -1) {
                                                    baggage.passengers.push(passenger.id);
                                                }
                                            }
                                        });
                                        if (!baggageFound) {
                                            baggageInfo = generateBaggageType(piece);
                                            segment.total += totalBaggage.total;
                                            calculateToltalBaggageRange(baggageInfo.quanty, piece.availablePriceRanges, piece.bundlePieces);
                                            if (baggageInfo.passengers.indexOf(passenger.id) === -1) {
                                                baggageInfo.passengers.push(passenger.id);
                                            }
                                            segment.baggages.push(baggageInfo);
                                        }
                                    }

                                });
                                isSegmentFound = true;
                            }
                        });

                        if (!isSegmentFound && trip.piecesChoosed > 0) {
                            segmentInfo = generateBaggageTrip(trip, passenger);
                            if (segmentInfo.total > 0) {
                                vm.model.baggages.segments.push(segmentInfo);
                            }
                        }
                    } else {
                        segmentInfo = generateBaggageTrip(trip, passenger);
                        if (segmentInfo.total > 0) {
                            vm.model.baggages.segments.push(segmentInfo);
                        }
                    }
                });
            });

            if (vm.model.baggages.segments.length > 0) {
                vm.model.baggages.hasBaggage = true;
            }

            checkBaggageSubtypes();
            calculateSubTotalBaggages();
            calculateAllBasket();


            saveHeaderModel();

            function generateBaggageTrip (trip, passenger) {
                const tripBaggage = { segmentId: trip.id, baggages: [], total: 0, origin: trip.departure, destination: trip.arrival };

                angular.forEach(trip.pieces, (piece) => {
                    baggage = { type: piece.subtype, quanty: piece.quantySelected, description: piece.description, passengers: [passenger.id] };
                    angular.extend(baggage, calculateToltalBaggageRange(piece.quantySelected, piece.availablePriceRanges, piece.bundlePieces));
                    if (baggage.quanty > 0) {
                        tripBaggage.baggages.push(baggage);
                        tripBaggage.total += baggage.total;
                    }
                });
                return tripBaggage;
            }

            function generateBaggageType (piece) {
                totalBaggage = calculateToltalBaggageRange(piece.quantySelected, piece.availablePriceRanges, piece.bundlePieces);
                return {
                    type: piece.subtype,
                    quanty: piece.quantySelected,
                    description: piece.description,
                    passengers: [],
                    total: totalBaggage.total,
                    totalFormatted: CurrencyService.formatPrice(vm.model.currency, totalBaggage.total, true)
                };
            }

            function calculateToltalBaggageRange (quantySelected, priceRanges, bundlePieces) {
                let i, numBag = 1, numBagsInterval, baggageCounter = 0, totalPrice = 0;
                if(bundlePieces) {
                    quantySelected += bundlePieces;
                }else{
                    bundlePieces = 0;
                }
                while (numBag <= quantySelected) {
                    if (quantySelected > 0) {
                        for (i = 0; i < priceRanges.length; i++) {
                            numBagsInterval = 1;
                            baggageCounter = priceRanges[i].to - priceRanges[i].from + 1;
                            while (numBagsInterval <= baggageCounter && numBag <= quantySelected) {
                                if(numBag > bundlePieces) {
                                    totalPrice += priceRanges[i].amount;
                                }
                                numBagsInterval++;
                                numBag++;
                            }
                        }
                    }
                }
                return { total: totalPrice, totalFormatted: CurrencyService.formatPrice(vm.model.currency, totalPrice, true) };
            }


            function checkBaggageSubtypes () {
                let baggages;
                if (vm.model.baggages.segments.length > 0) {
                    angular.forEach(vm.model.baggages.segments, (segment) => {
                        baggages = segment.baggages.filter((bag) => {
                            return (bag.quanty > 0);
                        });
                        segment.baggages = baggages;
                    });
                }
            }

            /*
            ** Modify max number of buyable baggages if bundle includes them
            */
            function calculateBundleBaggages (selectedBundle, passengerBaggages) {
                if(passengerBaggages) {
                    passengerBaggages.forEach(passenger => {
                        passenger.trips.forEach(trip => {
                            if(!trip.defaultAditionalPieces) {
                                trip.defaultAditionalPieces = trip.maxAdditionalPieces;
                            } else {
                                trip.maxAdditionalPieces = trip.defaultAditionalPieces;
                            }
                        });
                    });
                    if (selectedBundle) {
                        selectedBundle.items.forEach(item => {
                            if(item.type === 'BAGGAGE') {
                                passengerBaggages.forEach(passenger => {
                                    passenger.trips.forEach(trip => {
                                        trip.maxAdditionalPieces = trip.maxAdditionalPieces - item.quantityPassAndTrips;
                                        trip.pieces.forEach(piece => {
                                            if(piece.subtype === item.subtype) {
                                                // piece.availablePriceRanges.bundleBaggages = item.quantityPassAndTrips;
                                                piece.bundlePieces = item.quantityPassAndTrips;
                                            }
                                        });
                                    });
                                });
                            }
                        });
                    }
                }
            }
        }

        /**
         * Update or add bundle to basket model
         * @param {Object} evt Event
         * @param {Array} passengerBaggages List of passenger bundle
         */
        function updateHeaderBundle (evt, addedBundle) {
            vm.model.bundle.hasBundle = false;
            if(addedBundle) {
                vm.model.bundle.info = {
                    id: addedBundle.id,
                    items: addedBundle.items,
                    totalPassengers: addedBundle.totalPassengers
                };
                vm.model.bundle.total = {
                    total: addedBundle.priceItemsAllDiscount,
                    totalFormatted: CurrencyService.formatPrice(vm.model.currency, addedBundle.priceItemsAllDiscount, true)
                };

                vm.model.bundle.hasBundle = true;
            }
            calculateAllBasket();
            saveHeaderModel();
        }

        function calculateSubTotalBaggages () {
            let subTotal = 0;
            angular.forEach(vm.model.baggages.segments, (baggage) => {
                subTotal += baggage.total;
            });
            vm.model.baggages.total = {
                total: subTotal,
                totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
            };
        }

        /**
         * Update or add baggages to basket model
         * @param {Object} evt Event
         * @param {Array} passengerSpeqs List of passenger speqs
         */
        function updateHeaderSpeqs (evt, passengerSpeqs) {
            let isSegmentFound = false, segmentSpeqs, isSpeqFound, newSpeq, subTotal;
            vm.model.speqs.segments = [];
            angular.forEach(passengerSpeqs, (passenger) => {
                angular.forEach(passenger.trips, (trip) => {
                    isSegmentFound = false;
                    if (trip.speqsChoosed > 0) {
                        if (vm.model.speqs.segments.length > 0) {
                            angular.forEach(vm.model.speqs.segments, (segmentBasket) => {
                                if (trip.id === segmentBasket.segmentId) {
                                    trip.totalPrice += segmentBasket.total;
                                    angular.forEach(trip.pieces, (piece) => {
                                        if (piece.quantySelected > 0) {
                                            isSpeqFound = false;
                                            angular.forEach(segmentBasket.speqs, (speq) => {
                                                if (piece.subtype === speq.type) {
                                                    isSpeqFound = true;
                                                    segmentBasket.total -= speq.total;
                                                    speq.quanty += piece.quantySelected;
                                                    angular.extend(speq, calculateToltalSpeqRange(speq.quanty, piece.availablePriceRanges));
                                                    segmentBasket.total += speq.total;
                                                    if (speq.passengers.indexOf(passenger.id) === -1) {
                                                        speq.passengers.push(passenger.id);
                                                    }
                                                }
                                            });
                                            if (!isSpeqFound) {
                                                newSpeq = generateSpeq(piece, passenger);
                                                segmentBasket.total += newSpeq.total;
                                                segmentBasket.speqs.push(newSpeq);
                                            }
                                        }
                                    });
                                    isSegmentFound = true;
                                }
                            });

                            if (!isSegmentFound) {
                                vm.model.speqs.segments.push(generateSpeqTrip(trip, passenger));
                            }
                        } else {
                            vm.model.speqs.segments.push(generateSpeqTrip(trip, passenger));
                        }
                    }
                });
            });

            segmentSpeqs = vm.model.speqs.segments.filter((segment) => {
                return (segment.total > 0);
            });
            vm.model.speqs.segments = segmentSpeqs;

            if (vm.model.speqs.segments.length > 0) {
                vm.model.speqs.hasSpeqs = true;
            }

            checkSpeqSubtypes();
            calculateSubTotalSpeqs();
            calculateAllBasket();

            saveHeaderModel();

            function calculateSubTotalSpeqs () {
                subTotal = 0;
                angular.forEach(vm.model.speqs.segments, (speq) => {
                    subTotal += speq.total;
                });
                vm.model.speqs.total = {
                    total: subTotal,
                    totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
                };
            }

            function generateSpeqTrip (trip, passenger) {
                let tripSpeq = { segmentId: trip.id, speqs: [], total: trip.totalPrice, origin: trip.departure, destination: trip.arrival }, speqType;

                angular.forEach(passenger.trips, (pasTrip) => {
                    if (trip.id === pasTrip.id && pasTrip.speqsChoosed > 0) {
                        angular.forEach(trip.pieces, (piecePassenger) => {
                            if (piecePassenger.quantySelected > 0) {
                                tripSpeq.speqs.push(generateSpeq(piecePassenger, passenger));
                            }
                        });
                    }
                });

                return tripSpeq;
            }


            function generateSpeq (piece, passenger) {
                let speqType;
                speqType = { type: piece.subtype, quanty: piece.quantySelected, description: piece.description, passengers: [passenger.id] };
                angular.extend(speqType, calculateToltalSpeqRange(piece.quantySelected, piece.availablePriceRanges));
                return speqType;
            }


            function calculateToltalSpeqRange (quantySelected, priceRanges) {
                let i, numSpeq = 1, numSpeqsInterval, speqCounter = 0, totalPrice = 0;
                while (numSpeq <= quantySelected) {
                    if (quantySelected > 0) {
                        for (i = 0; i < priceRanges.length; i++) {
                            numSpeqsInterval = 1;
                            speqCounter = priceRanges[i].to - priceRanges[i].from + 1;
                            while (numSpeqsInterval <= speqCounter && numSpeq <= quantySelected) {
                                totalPrice += priceRanges[i].amount;
                                numSpeqsInterval++;
                                numSpeq++;
                            }
                        }
                    }
                }
                return { total: totalPrice, totalFormatted: CurrencyService.formatPrice(vm.model.currency, totalPrice, true) };
            }


            function checkSpeqSubtypes () {
                let speqs;
                if (vm.model.speqs.segments.length > 0) {
                    angular.forEach(vm.model.speqs.segments, (segment) => {
                        speqs = segment.speqs.filter((speq) => {
                            return (speq.quanty > 0);
                        });
                        segment.speqs = speqs;
                    });
                }
            }
        }


        /**
         * Update or add upgrading information
         * @param {Object} evt Event recieved
         * @param {Object} upgradingInfo Information of upgrading accepted by client to add on basket
         */
        function updateHeaderUpgrading (evt, upgradingInfo) {
            vm.model.upgrading.segments = upgradingInfo.upgradingTrips;
            if (vm.model.upgrading.segments && vm.model.upgrading.segments.length > 0) {
                vm.model.upgrading.hasUpgrading = true;
            } else {
                vm.model.upgrading.hasUpgrading = false;
            }
            vm.model.upgrading.total = upgradingInfo.total ? upgradingInfo.total : 0;
            vm.model.upgrading.totalFormatted = upgradingInfo.totalFormatted ? upgradingInfo.totalFormatted : 0;

            //calculateSubTotalUpgrading();
            calculateAllBasket();
            saveHeaderModel();
        }

        function calculateSubTotalUpgrading () {
            let subTotal = 0;
            angular.forEach(vm.model.upgrading.segments, (upgrading) => {
                subTotal += upgrading.total;
            });
            vm.model.upgrading.total = {
                total: subTotal,
                totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
            };
        }

        /**
         * Update or add insurance to basket
         * @param {Object} evt Event object emited by view
         * @param {Object} insurance Insurance information for update in basket
         */
        function updateHeaderInsurance (evt, insurance) {
            if (insurance) {
                vm.model.insurance.info = {
                    offer: insurance.id,
                    passengers: 1,
                    type: insurance.name
                };
                vm.model.insurance.total = {
                    total: insurance.originalPrice,
                    totalFormatted: CurrencyService.formatPrice(vm.model.currency, insurance.originalPrice, true)
                };
                vm.model.insurance.hasInsurance = true;
            } else {
                vm.model.insurance.info = null;
                vm.model.insurance.hasInsurance = false;
            }

            calculateAllBasket();
            saveHeaderModel();
        }

        /**
         * Update or add globick transfers ancillary to basket
         *
         * @param {Object} evt Event object emitted by view
         * @param {Object} globickTransfersInfo information for update in basket
         */
        function updateHeaderGlobickTransfers (evt, globickTransfersInfo) {
            if (globickTransfersInfo) {
                const price = globickTransfersInfo.price ? globickTransfersInfo.price : globickTransfersInfo.priceGoing;
                const totalFormatted = CurrencyService.formatPrice(vm.model.currency, price, true);
                vm.model.globickTransfers.info = {
                    date: globickTransfersInfo.dateGoingTrip,
                    dateReturn: '',
                    transferCar: globickTransfersInfo.transferCar,
                    totalFormatted: totalFormatted,
                    totalFormattedReturn: ''
                };
                vm.model.globickTransfers.total = {
                    total: price,
                    totalFormatted: totalFormatted
                };
                if (globickTransfersInfo.dateReturnTrip) {
                    const totalFormattedReturn = CurrencyService.formatPrice(vm.model.currency, globickTransfersInfo.priceReturn, true);
                    vm.model.globickTransfers.info.dateReturn = globickTransfersInfo.dateReturnTrip;
                    vm.model.globickTransfers.info.totalFormattedReturn = totalFormattedReturn;
                    vm.model.globickTransfers.total.total = globickTransfersInfo.priceGoing + globickTransfersInfo.priceReturn;
                    vm.model.globickTransfers.total.totalFormatted = CurrencyService.formatPrice(vm.model.currency, vm.model.globickTransfers.total.total, true);
                }
                vm.model.globickTransfers.hasTransfersGlobick = true;
            } else {
                vm.model.globickTransfers.info = null;
                vm.model.globickTransfers.total = null;
                vm.model.globickTransfers.hasTransfersGlobick = false;
            }
            calculateAllBasket();
            saveHeaderModel();
            $rootScope.$broadcast('clearViewOnBasketUpdate', false);
        }

        /**
         * Update or add globick activities ancillary to basket
         *
         * @param {Object} evt Event object emitted by view
         * @param {Object} globickActivitiesInfo information for update in basket
         */
        function updateHeaderGlobickActivities (evt, globickActivitiesInfo) {
            const globickActivitiesInfoHasTruthyValue = Object.keys(globickActivitiesInfo).some(key => globickActivitiesInfo[key]);
            if (globickActivitiesInfoHasTruthyValue) {
                const priceFormatted = [];
                let totalPrice = 0;
                angular.forEach(globickActivitiesInfo.price, (unitPrice) => {
                    totalPrice+=unitPrice;
                    priceFormatted.push(CurrencyService.formatPrice(vm.model.currency, unitPrice, true));
                });
                const totalFormatted = CurrencyService.formatPrice(vm.model.currency, totalPrice, true);
                vm.model.globickActivities.info = {
                    date: globickActivitiesInfo.dateGoingTrip,
                    description: globickActivitiesInfo.description,
                    totalFormatted: priceFormatted,
                    totalFormattedReturn: ''
                };
                vm.model.globickActivities.total = {
                    total: totalPrice,
                    totalFormatted: totalFormatted
                };
                vm.model.globickActivities.hasActivitiesGlobick = true;
            } else {
                vm.model.globickActivities.info = null;
                vm.model.globickActivities.total = null;
                vm.model.globickActivities.hasActivitiesGlobick = false;
            }
            calculateAllBasket();
            saveHeaderModel();
            $rootScope.$broadcast('clearViewOnBasketUpdate', false);
        }

        /**
         * Update or add globick transfers ancillary to basket
         *
         * @param {Object} evt Event object emitted by view
         * @param {Object} insuranceAllianzFusionInfo information for update in basket
         */
        function updateHeaderAllianzFusionInsurance (evt, insuranceAllianzFusionInfo) {

            if ( insuranceAllianzFusionInfo ) {
                const code = insuranceAllianzFusionInfo.code ? insuranceAllianzFusionInfo.code : null;
                const price = insuranceAllianzFusionInfo.price;
                const totalFormatted = CurrencyService.formatPrice(vm.model.currency, price, true);
                vm.model.insuranceAllianzFusionInfo.info = {
                    description: insuranceAllianzFusionInfo.description,
                    totalFormatted: totalFormatted
                };
                vm.model.insuranceAllianzFusionInfo.total = {
                    total: price,
                    totalFormatted: totalFormatted
                };
                if (code && code !== null) {
                    vm.model.insuranceAllianzFusionInfo.code = code;
                }
                vm.model.insuranceAllianzFusionInfo.hasInsuranceAllianzFusion = true;
            } else {
                vm.model.insuranceAllianzFusionInfo.info = null;
                vm.model.insuranceAllianzFusionInfo.total = null;
                vm.model.insuranceAllianzFusionInfo.hasInsuranceAllianzFusion = false;
            }
            calculateAllBasket();
            saveHeaderModel();
            $rootScope.$broadcast( 'clearViewOnBasketUpdate', false );
        }

        /**
         * Update or add carbon footprint ancillary to basket
         *
         * @param {Object} evt Event object emitted by view
         * @param {Object} carbonFootprintInfo information for update in basket
         */
        function updateHeaderCarbonFootprint (evt, carbonFootprintInfo) {
            if (carbonFootprintInfo) {
                const totalFormatted = CurrencyService.formatPrice(vm.model.currency, carbonFootprintInfo.price, true);
                vm.model.carbonFootprint.info = {
                    kilosCo2Equivalent: carbonFootprintInfo.kilosCo2Equivalent,
                    kilosCo2EquivalentFormatted: carbonFootprintInfo.kilosCo2Equivalent ? carbonFootprintInfo.kilosCo2Equivalent.toString().replace('.',',') : '',
                    totalFormatted: totalFormatted
                };
                vm.model.carbonFootprint.total = {
                    total: carbonFootprintInfo.price,
                    totalFormatted: totalFormatted
                };
                vm.model.carbonFootprint.hasCarbonFootprint = true;
            } else {
                vm.model.carbonFootprint.info = null;
                vm.model.carbonFootprint.total = null;
                vm.model.carbonFootprint.hasCarbonFootprint = false;
            }

            calculateAllBasket();
            saveHeaderModel();
            $rootScope.$broadcast('clearViewOnBasketUpdate', false);
        }


        /**
         * Enable loading view
         */
        function isLoadingBasket () {
            vm.isLoading = true;
        }

        /**
         * Disable loading view
         */
        function isNotLoadingBasket () {
            vm.isLoading = false;
        }


        /**
        * Change value of model depend of width of window.
        */
        function calculateModelTripsHeader () {
            const width = $window.innerWidth;
            const isTripsDefined = vm.model.trips && vm.model.trips.list;
            const hasElementsInList = isTripsDefined && vm.model.trips.list.length > 0;
            const isWidthLessThanOrEqualTo320 = width <= 320;
            const isWidthBetween321And1023 = width >= 321 && width < 1024;

            if (hasElementsInList) {
                if (isWidthLessThanOrEqualTo320 || isWidthBetween321And1023) {
                    vm.model.trips.tipFlights = angular.copy(vm.model.trips.list);
                } else if (width >= 1024 && width < 1280) {
                    vm.model.trips.tipFlights = angular.copy(vm.model.trips.list.slice(0, 3));
                } else if (width >= 1280) {
                    vm.model.trips.tipFlights = angular.copy(vm.model.trips.list.slice(0, 4));
                }
            }
        }


        /**
         * Set currency  of $rootScope to model  and update model on localStorage
         * @param {Object} evt Event object
         * @param {Object} currency Currency object
         */
        function updateCurrency (evt, currency) {
            if (!vm.model.currency) {
                vm.model.currency = currency;
                vm.model.total.formatted = CurrencyService.formatPrice(vm.model.currency, vm.model.total.original, true);
                saveHeaderModel();
                updateTotalBasket();
            }
        }


        /**
         * Update trips of header and calculate trips of tooltip depending of resolution of
         * screen
         * @param {Object} evt Event
         * @param {Object} info Object with list of trips and passengers number
         */
        function updateTrips (evt, info) {
            vm.model.trips.list = vm.model.trips.list.concat(info.trips);
            vm.model.trips.passengers = info.passengers;
            vm.model.segmentsInfo = info.segmentsInfo;
            calculateModelTripsHeader();
        }


        /**
         * Update all trips on model
         */
        function updateTripList (evt, trips) {
            if(vm.model && vm.model.trips) {
                vm.model.trips.list = trips;
            }
            saveHeaderModel();
            calculateModelTripsHeader();
        }


        /**
         * Add ancillaries to basket and calculate total price of all
         * @param {Object} evt
         * @param {Object} data Information for update all basket
         */
        function updateBasket (evt, data) {
            vm.model.baggages.segments = data.baggages;
            if (vm.model.baggages.segments.length > 0) {
                vm.model.baggages.hasBaggage = true;
            }

            vm.model.seats.segments = data.seats;
            if (vm.model.seats.segments.length > 0) {
                vm.model.seats.hasSeats = true;
            }

            vm.model.upgrading.segments = data.upgrading.upgradingTrips;
            vm.model.upgrading.total = data.upgrading.total;
            vm.model.upgrading.totalFormatted = data.upgrading.totalFormatted;

            if (vm.model.upgrading.segments.length > 0) {
                vm.model.upgrading.hasUpgrading = true;
            }

            vm.model.speqs.segments = data.speqs;
            if (vm.model.speqs.segments.length > 0) {
                vm.model.speqs.hasSpeqs = true;
            }

            vm.model.insurance.info = data.insurance;
            if (vm.model.insurance.info) {
                vm.model.insurance.hasInsurance = true;
            }

            vm.model.flexibilization.info = data.flexibilization;
            if (vm.model.flexibilization.info) {
                vm.model.flexibilization.hasFlexibilization = true;
            }

            vm.model.carbonFootprint.info = data.carbonFootprint;
            if (vm.model.carbonFootprint.info) {
                vm.model.carbonFootprint.hasCarbonFootprint = true;
            }

            vm.model.globickTransfers.info = data.globickTransfers;
            if (vm.model.globickTransfers.info) {
                vm.model.globickTransfers.hasTransfersGlobick = true;
            }

            vm.model.currency = data.currency;
            saveHeaderModel();
        }

        function updateMmbBasket (evt, data) {
            vm.model = data;
            saveHeaderModel();
        }
        function updateCkiBasket (evt, data) {
            vm.model = data;
            saveHeaderModel();
        }

        function calculateAllBasket (actualPage) {
            if (angular.isUndefined(vm.model.total.totalPrice)) {
                vm.model.total.totalPrice = 0;
            }
            if (actualPage === '/ibpurc' && vm.model.trips) {
                vm.model.total.totalPrice = vm.model.trips.total.original;
            }
            vm.model.total.original = vm.model.total.totalPrice;
            vm.model.total.formatted = CurrencyService.formatPrice(vm.model.currency, vm.model.total.original, true);
            angular.forEach(vm.model.baggages.segments, (segment) => {
                calculateTotalBasket(segment.total);
                calculateSubTotalBaggages();
            });

            angular.forEach(vm.model.seats.segments, (segment) => {
                calculateTotalBasket(segment.total);
                calculateSubTotalSeats();
            });

            if (vm.model.insurance.info) {
                calculateTotalBasket(vm.model.insurance.total.total);
            }

            if (vm.model.carbonFootprint.info) {
                calculateTotalBasket(vm.model.carbonFootprint.total.total);
            }

            if (vm.model.upgrading.hasUpgrading) {
                calculateTotalBasket(vm.model.upgrading.total);
                //calculateSubTotalUpgrading();
            }

            if (vm.model.othersModel.hasElements) {
                calculateTotalBasket(vm.model.othersModel.total.total);
            }

            if (vm.model.flexibilization.hasFlexibilization) {
                calculateTotalBasket(vm.model.flexibilization.info.amount.price);
            }

            if ((vm.model.discountsModel.hasDiscounts && !localStorageService.get('hasDiscountsApplied')) || (vm.model.discountsModel.hasDiscounts && actualPage === '/ibpurc')) {
                calculateTotalBasket(-vm.model.discountsModel.total);
                vm.model.discountsModel.totalFormatted = CurrencyService.formatPrice(vm.model.currency, -vm.model.discountsModel.discounts.total, true);
            }
            if(vm.model.bundle.hasBundle) {
                calculateTotalBasket(vm.model.bundle.total.total);
            }
            if(vm.model.globickTransfers.hasTransfersGlobick) {
                calculateTotalBasket(vm.model.globickTransfers.total.total);
            }
            if(vm.model.globickActivities.hasActivitiesGlobick) {
                calculateTotalBasket(vm.model.globickActivities.total.total);
            }
            if (vm.model.insuranceAllianzFusionInfo.hasInsuranceAllianzFusion) {
                calculateTotalBasket(vm.model.insuranceAllianzFusionInfo.total.total);
            }
            angular.forEach(vm.model.speqs.segments, (segment) => {
                calculateTotalBasket(segment.total);
                calculateSubTotalSpeqs();
            });
            if(vm.model.priorityBoarding && vm.model.priorityBoarding.info && vm.model.priorityBoarding.info.trips) {
                angular.forEach(vm.model.priorityBoarding.info.trips, (trip) => {
                    calculateTotalBasket(trip.amount);
                    calculateSubTotalPriority();
                });
            }


            function calculateTotalBasket (amount) {
                vm.model.total.original += amount;
                vm.model.total.formatted = CurrencyService.formatPrice(vm.model.currency, vm.model.total.original, true);
            }
            vm.model.total.formatted = CurrencyService.formatPrice(vm.model.currency, vm.model.total.original, true);
            $rootScope.$broadcast('totalBasket', vm.model.total.formatted);
            $rootScope.$broadcast('calculateHeightScrollEvent');
        }

        function calculateSubTotalSeats () {
            let subTotal = 0;
            angular.forEach(vm.model.seats.segments, (segment) => {
                subTotal += segment.total;
            });
            vm.model.seats.total = {
                total: subTotal,
                totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
            };
        }

        function calculateSubTotalSpeqs () {
            let subTotal = 0;
            angular.forEach(vm.model.speqs.segments, (speq) => {
                subTotal += speq.total;
            });
            vm.model.speqs.total = {
                total: subTotal,
                totalFormatted: CurrencyService.formatPrice(vm.model.currency, subTotal, true)
            };
        }

        function calculateSubTotalPriority () {
            let subTotal = 0;
            angular.forEach(vm.model.priorityBoarding.info.trips, (trip) => {
                subTotal += trip.amount;
            });
            vm.model.priorityBoarding.info.priceFormatted = CurrencyService.formatPrice(vm.model.currency, subTotal, true);
        }
        /**
         * Check if have early segments
         */
        function checkEarlySegments (sementSelectedId) {
            let isEarly = false;
            const bookingInfo = localStorageService.get('bookingInfo');
            angular.forEach(bookingInfo.checkinSegmentsInGroup, (earlySegmentId) => {
                if (earlySegmentId.toString() === sementSelectedId || earlySegmentId === sementSelectedId) {
                    isEarly = true;
                }
            });
            return isEarly;
        }

        function deleteFees () {
            ShoppingBasketViewModel.updateOthersFee({ shoppingBasket: vm.model });
            calculateAllBasket();
        }

        function updatePendingItems () {
            calculateAllBasket();
        }
        function loadingVoucherBasket (event, isLoading) {
            vm.isLoadingVoucher = isLoading;
        }

        function resetCurrency () {
            vm.model.currency = null;
        }
    }
})();